import AdminClubs from "../assets/icons/AdminClubs";
import DocumentText from "../assets/icons/DocumentText";
import Eye from "../assets/icons/Eye";
import Like from "../assets/icons/Like";
import ListBullet from "../assets/icons/ListBullet";
import NoEye from "../assets/icons/NoEye";
import Search from "../assets/icons/Search";
import UserPlus from "../assets/icons/UserPlus";
import Users from "../assets/icons/Users";
import Warning from "../assets/icons/Warning";
import femaleStudentProfile from "../assets/png/female-student-profile.png";
import {
  default as img,
  default as maleStudentProfile,
} from "../assets/png/male-student-profile.png";
import mock1 from "../assets/png/mock1.png";
import draft from "../assets/svg/draft-gray.svg";
import eyeGreen from "../assets/svg/eye-green.svg";
import timer from "../assets/svg/timer-orange.svg";

import BoardsMenu from "../assets/icons/BoardsMenu";
import CabsMenu from "../assets/icons/CabsMenu";
import CalendarTime from "../assets/icons/CalendarTime";
import { Door } from "../assets/icons/Door";
import { Laptop } from "../assets/icons/Laptop";
import { ListOfTicks } from "../assets/icons/ListOfTicks";
import { ManyUsers } from "../assets/icons/ManyUsers";
import MeetupMenu from "../assets/icons/MeetupMenu";
import { Megaphone } from "../assets/icons/Megaphone";
import { PersonWithExclamationSign } from "../assets/icons/PersonWithExclamationSign";
import girl1 from "../assets/png/female-student-profile.png";
import boy1 from "../assets/png/male-student-profile.png";
import { AverageGrade } from "../components/Users/AverageGrade";
import { Merits } from "../components/Users/Merits";
import { RoomRating } from "../components/Users/RoomRating";
import { AddEventFormFields } from "../types";
import {
  AccessItem,
  DisciplinaryCaseType,
  DisciplinaryStudentType,
} from "./types";
import { getDateOnly, socialTranscriptItemsReduce } from "./utils";
import { DocumentTextWarning } from "../assets/icons/DocumentTextWarning";
import { Key } from "../assets/icons/Key";
import { Lock } from "../assets/icons/Lock";
import { AdminCourses } from "../assets/icons/AdminCourses";
import { Document } from "../assets/icons/Document";
import { MultipleDocuments } from "../assets/icons/MultipleDocuments";
import { AdminExams } from "../assets/icons/AdminExams";
import AttendancePageIcon from "../assets/icons/AttendancePageIcon";

// import menuHome from "../assets/svg/menu-home.svg";
// import femaleStudentProfile from "../assets/png/female-student-profile.png";
// import maleStudentProfile from "../assets/png/male-student-profile.png";
// import likeWhite from "../assets/svg/like-white.svg";
// import likeBlack from "../assets/svg/like-black.svg";
// import searchBlue from "../assets/svg/search-blue.svg";
// import searchWhite from "../assets/svg/search-white.svg";
// import addPersonBlue from "../assets/svg/add-person-blue.svg";
// import addPersonWhite from "../assets/svg/add-person-white.svg";
// import { ReactComponent as boardsMenu } from "../assets/svg/boardsMenu.svg";
// import { ReactComponent as cabsMenu } from "../assets/svg/cabsMenu.svg";
// import { ReactComponent as news } from "../assets/svg/news.svg";
// import { ReactComponent as parents } from "../assets/svg/parentsMenu.svg";
// import { ReactComponent as staffMenu } from "../assets/svg/staffMenu.svg";
// import { ReactComponent as studentsMenu } from "../assets/svg/studentsMenu.svg";
// // import market from '../assets/svg/market.svg'
// import { ReactComponent as MarketIcon } from "../assets/svg/market.svg";
// import { ReactComponent as events } from "../assets/svg/events.svg";
// export const adminMenu = [
//   {
//     title: "Dashboard",
//     icon: menuHome,
//     nested: [
//       {
//         title: "Маркет",
//         link: "/admin/market/",
//         icon: MarketIcon,
//         key: "market",
//       },
//       {
//         title: "Новости",
//         link: "/admin/news/",
//         icon: news,
//         key: "news",
//       },
//       {
//         title: "События",
//         link: "/admin/events/",
//         icon: events,
//         key: "events",
//       },
//     ],
//   },
//   {
//     title: "Пользователи",
//     icon: menuHome,
//     nested: [
//       {
//         title: "Студенты",
//         link: "/admin/students/",
//         icon: studentsMenu,
//         key: "students",
//       },
//       {
//         title: "Стафф",
//         link: "/admin/staff/",
//         icon: staffMenu,
//         key: "staff",
//       },
//       {
//         title: "Родители",
//         link: "/admin/parents/",
//         icon: parents,
//         key: "parents",
//       },
//     ],
//   },
//   {
//     title: "Инфраструктура",
//     icon: menuHome,
//     nested: [
//       {
//         title: "Мои кабинеты",
//         link: "/admin/cabinets/",
//         icon: cabsMenu,
//         key: "cabinets",
//       },
//       {
//         title: "Мои доски",
//         link: "/admin/boards/",
//         icon: boardsMenu,
//         key: "boards",
//       },
//     ],
//   },
// ];

export const adminMenu = [
  {
    title: "Dashboard",
    nested: [
      // {
      //   title: "Маркет",
      //   link: "/admin/market/",
      //   // icon: MarketIcon,
      //   key: "market",
      // },
      // {
      //   title: "Новости",
      //   link: "/admin/news/",
      //   // icon: news,
      //   key: "news",
      // },
      // {
      //   title: "События",
      //   link: "/admin/events/",
      //   // icon: eventsIcon,
      //   key: "events",
      // },
      {
        role: "view_activities",
        title: "Мероприятия",
        link: "/admin/meetups/",
        icon: MeetupMenu,
        key: "meetups",
      },
    ],
  },
  {
    title: "Пользователи",
    nested: [
      {
        role: "view_house_of_student_organizations",
        title: "Посещаемость",
        link: "/admin/attendance/",
        icon: AttendancePageIcon,
        key: "attendance",
      },
      {
        role: "view_house_of_student_organizations",
        title: "House of Student Organizations",
        link: "/admin/clubs/",
        icon: AdminClubs,
        key: "clubs",
      },
      {
        role: "view_house_of_school_senates",
        title: "House of School Senates",
        link: "/admin/senate/",
        icon: AdminClubs,
        key: "senate",
      },
      {
        role: "view_disciplinary",
        title: "Дисциплинарный комитет",
        link: "/admin/disciplinary/",
        icon: AdminClubs,
        key: "disciplinary",
      },
      {
        role: "view_social_transcript",
        title: "Social transcript",
        link: "/admin/social-transcripts",
        icon: AdminClubs,
        key: "social-transcripts",
      },
      {
        role: "view_users",
        title: "Пользователи",
        link: "/admin/users",
        icon: ManyUsers,
        key: "users",
      },
      // {
      //   title: "Студенты",
      //   link: "/admin/students/",
      //   // icon: studentsMenu,
      //   key: "students",
      // },
      // {
      //   title: "Стафф",
      //   link: "/admin/staff/",
      //   // icon: staffMenu,
      //   key: "staff",
      // },
      // {
      //   title: "Родители",
      //   link: "/admin/parents/",
      //   // icon: parents,
      //   key: "parents",
      // },
    ],
  },
  {
    title: "Инфраструктура",
    nested: [
      {
        role: "view_courses",
        optionalUnixRoles: ["TEACHER"],
        title: "Курсы",
        link: "/admin/courses/",
        icon: AdminCourses,
        key: "courses",
      },
      {
        role: "view_exams",
        optionalUnixRoles: ["TEACHER"],
        title: "Экзамены",
        link: "/admin/exams/",
        icon: AdminExams,
        key: "exams",
      },
      {
        role: "view_cabinets",
        title: "Мои кабинеты",
        link: "/admin/cabinets/",
        icon: CabsMenu,
        key: "cabinets",
      },
      {
        role: "view_boards",
        title: "Мои Доски",
        link: "/admin/boards/",
        icon: BoardsMenu,
        key: "boards",
      },
      {
        role: "view_accesses",
        title: "Доступы",
        link: "/admin/accesses/",
        icon: ManyUsers,
        key: "accesses",
      },
      {
        role: "view_psychologist",
        title: "Психолог",
        link: "/admin/psychology/",
        icon: PersonWithExclamationSign,
        key: "psychologist",
      },
      {
        role: "view_boards",
        title: "Справки",
        link: "/admin/certificates/",
        icon: BoardsMenu,
        key: "certificates",
      },
    ],
  },
];

export const courseButtons = [
  {
    title: "Поиск на курсе",
    imageDefault: Search,
    key: "search",
  },
  {
    title: "Добавить студента",
    imageDefault: UserPlus,
    key: "add",
  },
];

export const studentBgColors = [
  "student-yellow",
  "student-green",
  "student-blue",
];

export const unauthorizedExceptions = ["/face-verify"];

export const clubMeta = [
  {
    clubTypeName: "club",
    pageTitle: "House of Student Organizations",
    leftTabText: "Список клубов",
    searchText: "Поиск по клубам",
    tableHeader: "Клуб",
    selfOfWhat: "клуба",
    createButton: "клуб",
  },
  {
    clubTypeName: "senate",
    pageTitle: "House of School Senates",
    leftTabText: "Список организаций",
    searchText: "Поиск по организациям",
    tableHeader: "Организация",
    selfOfWhat: "организации",
    createButton: "организацию",
  },
];

export const socialTranscriptItemStatuses = [
  {
    value: -1,
    label: "Отказано",
  },
  {
    value: 0,
    label: "На рассмотрении",
  },
];

export const meetupsTabs = [
  {
    key: "list",
    icon: Megaphone,
    label: "Список мероприятий",
    roles: [],
  },
  {
    key: "list-decide",
    icon: Megaphone,
    label: "Решение по мероприятиям",
    roles: ["decide_on_activities"],
  },
  {
    key: "categories",
    icon: ListBullet,
    label: "Виды категорий",
    roles: [],
  },
];

export const psychologistTabs = [
  {
    key: "calendar",
    icon: CalendarTime,
    label: "Календарь",
  },
  {
    key: "list",
    icon: ListBullet,
    label: "Список",
  },
];

export const userTabs = [
  {
    key: "demerits",
    label: "Выговоры",
  },
  {
    key: "social-transcript",
    label: "Социальный транскрипт",
  },
  {
    key: "psychologist",
    label: "История посещения психолога",
  },
];

export const userSocialTranscriptItemsTableColumns = [
  "Категория",
  "Пункт",
  "Дата загрузки",
  "Документ",
];

export const userPsychologistClientsTableColumnns = [
  "Психолог",
  "Дата встречи",
  "Время приёма",
  "Тип встречи",
  "",
];

export const psychologistAppointmentFormatDefault = {
  key: "all",
  label: "Все",
  value: 0,
};

export const psychologistListTableColumns = [
  "Студент",
  "Дата встречи",
  "Время приёма",
  "Тип встречи",
  "",
];

export const psychologistAppointmentFormats = [
  {
    key: "online",
    label: "Онлайн",
    textClassName: "text-valley-main",
    value: 1,
    Icon: Laptop,
  },
  {
    key: "offline",
    label: "Офлайн",
    textClassName: "text-valley-turquoise",
    value: 2,
    Icon: Door,
  },
];

export const userDisplayData = [
  {
    key: "social-transcript",
    label: "Социальный транскрипт",
    getData: (student: any) =>
      student.selectedStudent.social_transcript_items.reduce(
        socialTranscriptItemsReduce,
        0,
      ),
  },
  {
    key: "average-grade",
    label: "Средняя оценка",
    Component: AverageGrade,
  },
  {
    key: "room-rating",
    label: "Оценка комнаты",
    Component: RoomRating,
  },
  {
    key: "achievements",
    label: "Награды",
    Component: Merits,
  },
];

export const clubTabs = [
  {
    key: "list",
    icon: Megaphone,
  },
  {
    key: "categories",
    icon: ListBullet,
    label: "Виды категорий",
  },
];

export const getStudentBgColor = (length: number) => {
  return studentBgColors[length % 3];
};

export const teachers = [
  "Байрамов В.О.",
  "Телебаев Г.Т.",
  "Тучашвили Д.",
  "Сутченко Ю.В.",
  "Зиро А.А.",
];

export const timeStamps = [
  "Суббота 08:00 - 10:00",
  "Четверг 13:00 - 14:00",
  "Среда 16:00 - 17:00",
  "Среда 17:00 - 19:00",
  "Вторник 14:00 - 17:00",
  "Вторник 11:00 - 13:00",
  "Суббота 08:00 - 10:00",
];

export const boardBgColors = [
  "bg-board-light-red",
  "bg-board-light-orange",
  "bg-board-light-green",
  "bg-board-light-turquoise",
  "bg-board-light-violet",
  "bg-board-light-pink",
];

export const boardColumns = [
  {
    label: "В ожидании",
    bgColor: "bg-violet-task",
    textColor: "text-violet-task",
  },
  {
    label: "В процессе",
    bgColor: "bg-green-in-progress",
    textColor: "text-violet-task",
  },
  {
    label: "Сделано",
    bgColor: "bg-blue-done",
    textColor: "text-white",
  },
];

export const students = [
  {
    name: "Сакуш Камила",
    image: femaleStudentProfile,
  },
  {
    name: "Асылниет Жетписбай",
    image: maleStudentProfile,
  },
];

export const likes = [129, 79, 100, 154];

export const likeClasses = [
  {
    className: "like-active",
    icon: Like,
    color: "text-white",
  },
  {
    className: "like-inactive",
    icon: Like,
    color: "text-black",
  },
];

export const pageHeaders = {
  "/admin/cabinets/": {
    match: "exact",
    crumbs: ["Мои кабинеты", "Список кабинетов"],
  },
  "/admin/boards/": {
    match: "exact",
    crumbs: ["Доски"],
  },
  "/admin/cabinets/:id": {
    match: "param",
    check: (pathname: string) => {
      const splitted = pathname.split("/").filter((s) => !!s.length);
      return (
        splitted.length === 3 &&
        splitted.slice(0, splitted.length - 1).join("/") === "admin/cabinets" &&
        !!splitted[splitted.length - 1]
      );
    },
    crumbs: ["Мои кабинеты", "Список кабинетов", "Информация о кабинете"],
  },
};

export const events = [
  {
    id: 1,
    title: "KAZ Code YouTube challenge",
    publishDate: "01.07.2024",
    status: "Опубликовано",
    img: mock1,
    actions: ["Вернуть в черновики", "Выгрузить заявки"],
    url: "https://",
    descr: "",
  },
  {
    id: 2,
    title: "Однодневный семинар IELTS оффлайн/онлайн",
    publishDate: "-",
    status: "Черновик",
    img: mock1,
    actions: ["Опубликовать"],
    url: null,
    descr: "",
  },
];

export const eventStatuses = [
  {
    status: "Опубликовано",
    color: "#3BBC30",
    img: eyeGreen,
  },
  {
    status: "Черновик",
    color: "#5F6B88",
    img: draft,
  },
  {
    status: "Отложенная публикация",
    color: "#F58500",
    img: timer,
  },
];

export const clubTableList = [
  "Клуб",
  "Описание",
  "Президент",
  "Направление",
  "Кол-во уч-ов",
  "Статус",
  "",
];

export const clubTableListWidths: Record<string, number> = {
  "Кол-во уч-ов": 150,
};

export const clubMembersList = ["Участник", "Президент"];

export const clubTableItems = [
  {
    id: 1,
    title: "Гиревой спорт",
    description:
      "Циклический силовой вид спорта, в основе которого лежит подъём гирь максимально возможное число раз за отведённый промежуток времени в положении стоя.",
    created_at: "14.11.2024",
    status: true,
    category: "Спорт",
    administrator_info: {
      name: "Турдиев Сакен Анарбекович",
      surname: "Барушева",
      img: img,
      email: "am_bolat@kbtu.kz",
    },
  },
  {
    id: 2,
    title: "Клуб любителей бега трусцой на длинные дистанции в хорошую погоду",
    description:
      "Циклический силовой вид спорта, в основе которого лежит подъём гирь максимально возможное число раз за отведённый промежуток времени в положении стоя.",
    created_at: "14.11.2024",
    status: false,
    category: "Спорт",
    administrator_info: {
      name: "Турдиев Сакен Анарбекович",
      surname: "Барушева",
      img: img,
      email: "am_bolat@kbtu.kz",
    },
  },
];

export const meetupsTableList = [
  "Просмотр",
  "Изображение",
  "Заголовок",
  "Дата",
  "Департамент",
  "Категория",
  "Аудитория",
  "Локация",
  "Статус мероприятия",
  "",
];

export const meetupsTableListAdmin = [
  "Просмотр",
  "Изображение",
  "Заголовок",
  "Дата",
  "Департамент",
  "Категория",
  "Аудитория",
  "Локация",
  "",
];

export const meetupsTableListWidths: Record<string, number> = {
  Просмотр: 100,
  Департамент: 200,
  Аудитория: 100,
  Локация: 100,
  Дата: 120,
  Категория: 90,
  Изображение: 120,
  Заголовок: 180,
  "Статус мероприятия": 150,
  "": 60,
};

export const examTableColumns = [
  "№",
  "Название",
  "Курс",
  "Класс(-ы)",
  "Дата и время",
  "Статус",
  "",
];

export const certificatesTableColumns = [
  "Студент",
  "Тип справки",
  "Дата запроса",
  "",
];

export const meetupsTableItems = [
  {
    id: 1,
    title: "KAZ Code YouTube Challenge",
    img: mock1,
    created_at: "01.07.2024",
    status: "pending",
    category: "Спорт",
    department: "Департамент соц. вопросов",
    descr: `Федерация спортивного программирования приглашает вас принять участие в конкурсе KazCodeYouTubeChallenge по программированию на казахском языке. 
    Немного о конкурсе:
  • Суммарный призовой фонд 1 000 000 тг.
  • Конкурс по категориям: "Разбор задач" по спортивному программированию и "Разбор тем" по алгоритмам и языкам программирования, приглашаем принять участие и начинающих программистов для разбора базовых тем.
  Все что нужно сделать:
  1 . Загрузить на свой YouTube канал не менее трех видео в рамках выбранной категории.
  2 . Заполнить форму отправки видео, предоставив ссылку на ваш канал YouTube.
  Мы приглашаем всех желающих принять участие в конкурсе и внести свой вклад в развитие казахскоязычного контента на YouTube! Поторопитесь, ведь конкурс продлится только до конца февраля 2024 года.`,
    time: "10:00-11:00",
    comment: "",
  },
  {
    id: 2,
    title: "KAZ Code YouTube challenge",
    img: mock1,
    created_at: "01.07.2024",
    status: "rejected",
    category: "Спорт",
    department: "Департамент соц. вопросов",
    descr: "",
    comment: "test",
  },
  {
    id: 3,
    title: "Тест тест",
    img: mock1,
    created_at: "03.07.2024",
    status: "pending",
    category: "Тест",
    department: "Департамент соц. вопросов",
    descr: "",
    comment: "",
  },
  {
    id: 4,
    title: "KAZ Code YouTube challenge",
    img: mock1,
    created_at: "01.07.2024",
    status: "approved",
    category: "cat3",
    department: "admin2",
    descr: "",
    comment: "",
  },
];

export const clubFormStatusOptions = [
  {
    value: 1,
    label: "Видимый",
    icon: Eye,
  },
  {
    value: 0,
    label: "Заблокирован",
    icon: NoEye,
  },
];

export const createLessonTypeOptions = [
  {
    value: 0,
    label: "Провести урок",
  },
  {
    value: 1,
    label: "Провести экзамен",
  },
];

export const dormBlacklistOptions = [
  {
    value: 0,
    label: "Нет",
    icon: Key,
  },
  {
    value: 1,
    label: "Да",
    icon: Lock,
  },
];

export const tabs = [
  { id: "students", Icon: Users, label: "Список студентов", roles: [] },
  { id: "warnings", Icon: Warning, label: "Нарушения", roles: [] },
  {
    id: "decide_cases",
    Icon: ListOfTicks,
    label: "На одобрении",
    roles: ["decide_on_disciplinary_cases"],
  },
  { id: "cases", Icon: DocumentText, label: "Дела", roles: [] },
  {
    id: "hearings_cases",
    Icon: DocumentTextWarning,
    label: "Список дел",
    roles: ["create_hearings"],
  },
  {
    id: "hearings",
    Icon: CalendarTime,
    label: "Заседания",
    roles: ["create_hearings"],
  },
  {
    id: "species",
    Icon: ListBullet,
    label: "Виды нарушений",
    roles: ["view_demerit_types"],
  },
];

export const targetAudienceEmptyOption = { label: "Все", value: 0 };

export const disciplinaryCaseList: DisciplinaryCaseType[] = [
  {
    id: 1,
    title: "Дело №1. Распитие алкоголя в университете 19.11.2024",
    status: "pending",
    table_items: [
      {
        id: 1,
        type: "Распитие алкоголя в университете",
        created_at: "14.11.2024",
        status: "active",
        student_info: {
          name: "Аружан",
          surname: "Барушева",
          img: girl1,
        },
      },
      {
        id: 2,
        type: "Распитие алкоголя в университете",
        created_at: "14.11.2024",
        status: "active",
        student_info: {
          name: "Аманай",
          surname: "Балат",
          img: boy1,
        },
      },
      {
        id: 3,
        type: "Распитие алкоголя в университете",
        created_at: "14.11.2024",
        status: "active",
        student_info: {
          name: "Данила",
          surname: "Дементьев",
          img: boy1,
        },
      },
    ],
  },
  {
    id: 2,
    title: "Дело №2. Курение 19.11.2024",
    status: "rejected",
    table_items: [
      {
        id: 1,
        type: "Курение",
        created_at: "14.11.2024",
        status: "active",
        student_info: {
          name: "Аружан",
          surname: "Барушева",
          img: girl1,
        },
      },
    ],
  },
];

export const disciplinaryStudentsList: DisciplinaryStudentType[] = [
  {
    id: 1,
    name: "Аружан",
    surname: "Барушева",
    email: "b_aruzhan@kbtu.kz",
    img: girl1,
    social_transcript: 128,
    room_value: 2,
    warnings_amount: 1,
    gender: "Женский",
    gpa: "3.5",
    average_score: "88.5",
  },
  {
    id: 2,
    name: "Аманай",
    surname: "Балат",
    email: "am_bolat@kbtu.kz",
    img: boy1,
    social_transcript: 128,
    room_value: 2,
    warnings_amount: 1,
    gender: "Мужской",
    gpa: "3.8",
    average_score: "85",
  },
];

export const addEventFormFields: (keyof AddEventFormFields)[] = [
  "id",
  "main_image",
  "department_id",
  "category_id",
  "start_date",
  "end_date",
  "name",
  "description",
  "activity_target_audience_id",
  "expected_reach",
  "accept_applications",
  "level",
  "location",
];

export const meetupStatuses = [
  {
    value: 0,
    label: "На рассмотрении",
  },
  {
    value: 1,
    label: "Одобрено",
  },
  {
    value: 2,
    label: "Опубликовано",
  },
  {
    value: -1,
    label: "Отклонено",
  },
];

export const categories = [
  {
    id: 1,
    title: "Волонтёрство",
    items: [
      {
        id: 1,
        title: "Волонтёрство у партнёров",
        descr:
          "Циклический силовой вид спорта, в основе которого лежит подъём гирь максимально возможное число раз за отведённый промежуток времени в положении стоя.",
        points: 200,
      },
      {
        id: 2,
        title: "Волонтёрство в университете",
        descr:
          "В качестве оздоровительного средства бег трусцой может использоваться",
        points: 150,
      },
      {
        id: 3,
        title:
          "Волонтёрство на мероприятиях спортивного характера с возможным участием студента",
        descr:
          "Задачей соперников — тенниси́ста или тенниси́стки — является при помощи ракеток отправлять мяч на сторону соперника",
        points: 100,
      },
    ],
  },
  {
    id: 2,
    title: "Мероприятия",
    items: [
      {
        id: 4,
        title: "Волонтёрство у партнёров",
        descr:
          "Циклический силовой вид спорта, в основе которого лежит подъём гирь максимально возможное число раз за отведённый промежуток времени в положении стоя.",
        points: 200,
      },
      {
        id: 5,
        title: "Волонтёрство в университете",
        descr:
          "В качестве оздоровительного средства бег трусцой может использоваться",
        points: 150,
      },
      {
        id: 6,
        title:
          "Волонтёрство на мероприятиях спортивного характера с возможным участием студента",
        descr:
          "Задачей соперников — тенниси́ста или тенниси́стки — является при помощи ракеток отправлять мяч на сторону соперника",
        points: 100,
      },
    ],
  },
];

export const documents = [
  {
    id: 1,
    profile: girl1,
    name: "Аружан Барушева",
    category: " Волонтёрство",
    item: "Волонтёрство у партнёров",
    uploadTime: "23.10.2023",
    doc: "Подробное описание действий при пожарe",
    status: "pending",
  },
  {
    id: 2,
    profile: girl1,
    name: "Андрей Барушева",
    category: " Волонтёрство",
    item: "Волонтёрство у партнёров",
    uploadTime: "23.10.2023",
    doc: "Подробное описание действий при пожарe",
    status: "rejected",
  },
];

export const accessesTableList: AccessItem[] = [
  {
    title: "События",
    nested: ["Создание", "Подтверждение"],
  },
  {
    title: "Смартрум",
    nested: ["Доступ"],
  },
  {
    title: "Новости",
    nested: ["Создание", "Подтверждение"],
  },
  {
    title: "Организации",
    nested: ["Управление"],
  },
  {
    title: "Доски",
    nested: ["Управление"],
  },
  {
    title: "Менторы",
    nested: ["Управление"],
  },
  {
    title: "Кабинеты",
    nested: ["Управление"],
  },
  {
    title: "",
    nested: [""],
  },
];

export const accessesTableUsers = [
  {
    img: boy1,
    name: "Аманай Балат",
    email: "am_bolat@kbtu.kz",
    accesses: {
      events: {
        create: true,
        confirm: true,
      },
      smartroom: {
        access: false,
      },
      news: {
        create: true,
        confirm: true,
      },
      organizations: {
        control: false,
      },
      descs: {
        control: false,
      },
      mentors: {
        control: false,
      },
      cabinets: {
        control: false,
      },
      delete: {
        delete: "",
      },
    },
  },
  {
    img: girl1,
    name: "Аружан Барушева",
    email: "b_aruzhan@kbtu.kz",
    accesses: {
      events: {
        create: true,
        confirm: true,
      },
      smartroom: {
        access: true,
      },
      news: {
        create: true,
        confirm: true,
      },
      organizations: {
        control: true,
      },
      descs: {
        control: true,
      },
      mentors: {
        control: true,
      },
      cabinets: {
        control: true,
      },
      delete: {
        delete: "",
      },
    },
  },
];

export const clubMembersExcel = [
  {
    label: "Фамилия",
    rawData: (item: any) => item.json_saved_data?.lastname,
  },
  {
    label: "Имя",
    rawData: (item: any) => item.json_saved_data?.firstname,
  },
  {
    label: "External ID",
    rawData: (item: any) => item.json_saved_data?.externalId,
  },
  {
    label: "Президент",
    rawData: (item: any) => (item.club_members?.is_admin ? "Да" : ""),
  },
];

export const lessonReportExcel = [
  {
    label: "ID *",
    rawData: (item: any) => item.json_saved_data?.externalId,
  },
  {
    label: "Student",
    rawData: (item: any) =>
      `${item.json_saved_data?.lastname} ${item.json_saved_data?.firstname}`,
  },
  {
    label: "Attended",
    rawData: (item: any) => (item.did_attend ? "Yes" : "No"),
  },
  {
    label: "Late",
    rawData: () => "-",
  },
  {
    label: "Absent",
    rawData: (item: any) => (!item.did_attend ? "Yes" : "No"),
  },
  {
    label: "Grade",
    rawData: (item: any) => (typeof item.grade === "number" ? item.grade : "-"),
  },
  {
    label: "Comments",
    rawData: () => "",
  },
  {
    label: "Statistic",
    rawData: (item: any) => {
      const passes = item.did_attend ? 1 : 0;
      const score = typeof item.grade === "number" ? item.grade : 0;
      return `${passes} passes. Total score ${score.toFixed(2)}`;
    },
  },
];

export const meetupsExcel = [
  {
    label: "Событие",
    rawData: (item: any) => item.name,
  },
  {
    label: "Дата",
    rawData: (item: any) =>
      `${getDateOnly(item.start_date)}-${getDateOnly(item.start_date)}`,
  },
  {
    label: "Отв",
    rawData: (item: any) => item.department?.title,
  },
  {
    label: "Описание",
    rawData: (item: any) =>
      new DOMParser().parseFromString(item.description, "text/html").body
        .textContent,
  },
];

export const clubsExcel = [
  {
    label: "№",
    type: "order",
  },
  {
    label: "Направление",
    rawData: (item: any) => item.category?.name,
  },
  {
    label: "Название организации",
    rawData: (item: any) => item.name,
  },
  {
    label: "Описание организации",
    rawData: (item: any) => item.description,
  },
  {
    label: "Президент",
    rawData: (item: any) => {
      const foundAdmin = item.members.find(
        (m: any) => m.club_members.is_admin,
      )?.json_saved_data;
      return `${foundAdmin?.firstname} ${foundAdmin?.lastname} (${foundAdmin?.email})`;
    },
  },
  {
    label: "Количество участников",
    rawData: (item: any) =>
      item.members.filter((m: any) => m.club_members.status === 2).length,
  },
];

export const timeSlots = Array.from(
  { length: ((24 - 9) * 60) / 15 + 1 },
  (_, i) => new Date(0, 0, 0, 9, i * 15).toTimeString().slice(0, 5),
);

export const lessonActions = [
  {
    Icon: Document,
    text: "Домашнее задание",
    key: "homework",
  },
  {
    Icon: AdminCourses,
    text: "Тест",
    key: "test",
  },
  {
    Icon: MultipleDocuments,
    text: "Доп. материал",
    key: "additional",
  },
];

export const socialTranscriptExcel = [
  {
    label: "№",
    type: "order",
  },
  {
    label: "Категория",
    rawData: (item: any) =>
      item.social_subcategory?.social_category?.name || "",
  },
  {
    label: "Пункт",
    rawData: (item: any) => item.social_subcategory?.name || "",
  },
  {
    label: "Дата загрузки",
    rawData: (item: any) => getDateOnly(item.createdAt),
  },
  {
    label: "Документ",
    rawData: (item: any) =>
      item.media?.[0]?.filename || item.media?.[0]?.link || "",
  },
];

export const demeritStatusMapper: Record<number, string> = {
  0: "В работе",
  1: "Решение принято",
  2: "Завершён",
  [-1]: "Отменён",
  [-2]: "Отменён",
};
